import type { FC } from 'react'
import { Link } from 'react-router'
import { twJoin } from 'tailwind-merge'

import Theme from '@/lib/ui/theme'
import tasLogo from '@/assets/tas.svg'

type NavbarProps = {
  className?: string
}

export const Navbar: FC<NavbarProps> = ({ className }) => (
  <nav
    className={twJoin(
      'flex h-16 w-full items-center px-4',
      'bg-stone-100 dark:bg-black',
      'border-b border-stone-300 dark:border-stone-700',
      className
    )}
  >
    <Link to='/' tabIndex={0} className='hover:bg-transparent'>
      <img src={tasLogo} alt='TAS Logo' className='size-10' />
    </Link>
    <ul className='ml-auto flex items-center gap-4'>
      {/* <li>
        <Link to='/' tabIndex={0}>
          Home
        </Link>
      </li>
      <li>
        <Link to='/about' tabIndex={0}>
          About
        </Link>
      </li>
      <li>
        <Link to='/contact' tabIndex={0}>
          Contact
        </Link>
      </li> */}
      <li>
        <Theme />
      </li>
    </ul>
  </nav>
)

export default Navbar
